export default function() {
    return {
        activeCT: '',
        coachingTracks: [],
        timelines: [],
        timeline: {},
        sharePost: {},
        createPostDialog: false,
        editPostDialog: false,
        sharePostDialog: false,
        lastUpdated: null,
        taggableUsers: [],
        coacheeViewActionItems: [],
        coachViewActionItems: [],
    }
}
